import { useThemeContext } from '#contexts/ThemeContext';
import { InfoHelperIcon } from '#images/icon';
import { Answer, QuestionnaireElements } from '#models/questionnaire';
import { useAnswerStyles } from '#styles/imageAnswer';
import { Box, Checkbox, makeStyles, Paper, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { CheckOutlined, CloseOutlined } from '@material-ui/icons';
import { colors } from '@swyft/ui';
import * as React from 'react';

interface MultipleAnswerProps {
  answer: Answer;
  showHelperText: any;
  selected?: boolean;
  multipleSelection?: boolean;
}

const useStyles = (
  { answerCardSelectedState, helperIconLink, isTouchDevice, answerText }: Partial<QuestionnaireElements>,
  isSmDown: Boolean
) =>
  makeStyles((theme: any) => ({
    answerText: {
      color: answerText
    },
    helperIconContainer: {
      position: 'absolute',
      padding: 0,
      top: 5,
      right: 5
    },
    icon: {
      color: helperIconLink
    },
    answerBox: {
      width: '100%',
      outline: '1px solid transparent',
      cursor: 'pointer',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        outlineColor: isTouchDevice || isSmDown ? 'transparent' : answerCardSelectedState + '!important'
      }
    },
    answerBoxSelected: {
      outlineColor: answerCardSelectedState + '!important'
    }
  }));

export const MultipleAnswer = ({ answer, selected, multipleSelection }: MultipleAnswerProps) => {
  const themeMaterial = useTheme();
  const isSmDown = useMediaQuery(themeMaterial.breakpoints.down('sm'));
  const theme = useThemeContext();
  const classes = useStyles(theme, isSmDown)();
  const [isShowHelperText, setIsShowHelperText] = React.useState<boolean>(false);
  const classCard = useAnswerStyles(isShowHelperText)();

  const handleClickIcon = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsShowHelperText(!isShowHelperText);
  };

  return (
    <Paper className={`${classes.answerBox} ${selected ? classes.answerBoxSelected : ''}`}>
      <Box position='relative' width='100%' display='flex' flexWrap='wrap'>
        <Box
          display='flex'
          padding={1}
          alignItems='center'
          width={answer.helperText ? 'calc(100% - 60px)' : '100%'}
          minHeight={{ xs: 60, sm: 80 }}
        >
          {multipleSelection && (
            <Box>
              <Checkbox
                color='primary'
                checked={selected}
                style={{ padding: '0px 0.625rem' }}
                className={classCard.checkbox}
                checkedIcon={<CheckOutlined />}
              />
            </Box>
          )}
          <Box pl={2} width={`calc(100% - ${multipleSelection ? 50 : 0}px)`}>
            <Typography variant='subtitle2' className={classCard.smallAnswerText}>
              {answer.text}
            </Typography>
          </Box>
        </Box>
        {answer.helperText && (
          <Box
            className={classCard.helperAnswerWrapper}
            width={{ xs: 60 }}
            display='flex'
            justifyContent='center'
            alignItems='center'
            bgcolor={isShowHelperText ? theme.primaryButtonBackground : 'unset'}
            onClick={(e) => handleClickIcon(e)}
          >
            {!isShowHelperText ? (
              <InfoHelperIcon className='helperIcon' />
            ) : (
              <CloseOutlined style={{ color: theme.primaryButtonText }} />
            )}
          </Box>
        )}
        {answer.helperText && isShowHelperText && (
          <Box p={2} width={'100%'} borderTop={`1px solid ${colors.grey[50]}`}>
            <Typography variant='caption' style={{ color: theme.answerHelperText }}>
              {answer.helperText}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};
